import React from 'react';
import { Typography } from 'antd';

const { Text, Link } = Typography;

interface LegalFooterProps {
  compact?: boolean;
}

const LegalFooter: React.FC<LegalFooterProps> = ({ compact = false }) => {
  return (
    <div
      style={{
        padding: compact ? '16px 24px' : '20px 24px',
        borderTop: '1px solid var(--glass-border)',
        background: 'var(--bg-secondary)',
        textAlign: 'center',
      }}
    >
      <Text type="secondary">
        주식회사 코스타트 | 대표자 박정근 | 사업자등록번호 707-86-03946 | 통신판매업신고번호 제2026-서울광진-0187호
      </Text>
      <br />
      <Text type="secondary">
        서울특별시 광진구 광나루로 478 광진경제허브센터 | 문의: help@star-t.io
      </Text>
      <br />
      <Text type="secondary">
        <Link href="/legal/terms.html" target="_blank">이용약관</Link>
        {' | '}
        <Link href="/legal/privacy.html" target="_blank">개인정보처리방침</Link>
        {' | '}
        <Link href="/legal/idea-protection.html" target="_blank">아이디어·정보 보호</Link>
        {' | '}
        <Link href="/legal/refund.html" target="_blank">환불·취소정책</Link>
        {' | '}
        <Link href="/legal/marketing.html" target="_blank">마케팅 수신동의</Link>
      </Text>
    </div>
  );
};

export default LegalFooter;
